import { SET_GLOBALS, SET_IS_LOADING, SET_GLOBAL_ERROR, SET_PAGE_DATA, SET_LANGUAGE_DATA, SET_USER, SET_CAN_SCROLL } from './globals.types';
import mainApi from '../apis/main-api';

export const setIsLoading = (isLoading) => {
	return {
		type: SET_IS_LOADING,
		payload: isLoading,
	};
};

export const setCanScroll = (canScroll) => {
	return {
		type: SET_CAN_SCROLL,
		payload: canScroll,
	};
};

export const setGlobalError = (error) => {
	return {
		type: SET_GLOBAL_ERROR,
		payload: error,
	};
};

export const setUser = (payload) => {
	return {
		type: SET_USER,
		payload: payload,
	};
};

export const getLogedUser = () => {
	return async (dispatch) => {
		const endpoint = '/APIS/user/getLogedUser';
		return await mainApi.get(endpoint);
	};
};

export const userLogin = ({ email, password, playAsGuest }) => {
	return async (dispatch) => {
		const endpoint = '/APIS/user/login';
		return await mainApi.post(endpoint, { email: email, password: password, playAsGuest: playAsGuest });
	};
};

export const userLogout = () => {
	return async (dispatch) => {
		const endpoint = '/APIS/user/logout';
		return await mainApi.post(endpoint);
	};
};

export const updateSelectedDriver = (driver) => {
	return async (dispatch) => {
		const endpoint = '/APIS/user/updateDriver';
		return await mainApi.post(endpoint, driver);
	};
};

export const userRegister = ({ name, lastname, email, password }) => {
	return async (dispatch) => {
		const endpoint = '/APIS/user/register';
		return await mainApi.post(endpoint, { name, lastname, email, password });
	};
};

export const userForgotPassword = (email) => {
	return async (dispatch) => {
		const endpoint = '/API/user/forgot';
		return await mainApi.post(endpoint, { email: email });
	};
};

export const userConfirmForgotPassword = (token, password) => {
	return async (dispatch) => {
		const endpoint = '/API/user/forgot/confirm';
		return await mainApi.post(endpoint, { token: token, password: password });
	};
};

export const setDataForURL = (data) => {
	return {
		type: SET_PAGE_DATA,
		payload: data,
	};
};

export const setLanguagesForPage = (data) => {
	return {
		type: SET_LANGUAGE_DATA,
		payload: data,
	};
};
